import {
  pathogenicityLabelsLong,
  pathogenicityIndex,
  pathogenicityFilters,
} from "../../constants/pathogenicity";
import Filter from "../../../../models/Filter";
import { ZYGOSITY_LABELS } from "../../constants/zygosity";
import { precisionLabels } from "../../constants/dellyPrecision";
import { cnvTypeLabels } from "../../constants/cnvTypes";

function getFilters() {
  const pathoFilters = Array.from(
    new Set(Object.values(pathogenicityIndex))
      .filter((x) => pathogenicityFilters[x])
      .map(
        (x) =>
          new Filter({
            category: "Germline Classification",
            key: `path-${x}`,
            label: pathogenicityLabelsLong[x],
          })
      )
      .values()
  );

  const precisionFilters = Array.from(
    new Set(Object.values(pathogenicityIndex))
      .filter((x) => pathogenicityFilters[x])
      .map(
        (x) =>
          new Filter({
            category: "Delly Precision",
            key: `prec-${x}`,
            label: precisionLabels[x],
          })
      )
      .values()
  );

  const typeFilters = Array.from(
    new Set(Object.values(pathogenicityIndex))
      .filter((x) => pathogenicityFilters[x])
      .map(
        (x) =>
          new Filter({
            category: "Type",
            key: `type-${x}`,
            label: cnvTypeLabels[x],
          })
      )
      .values()
  );

  const zygosityFilters = Object.keys(ZYGOSITY_LABELS).map((x) => {
    return new Filter({
      key: `zygo-${x}`,
      value: 0,
      label: ZYGOSITY_LABELS[x],
      category: "Zygosity",
    });
  });

  return [
    ...pathoFilters,
    ...zygosityFilters,
    ...precisionFilters,
    ...typeFilters,
  ];
}

export default getFilters;
